import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../shared/dummy.component';
import { Router } from '@angular/router';
import { Utils } from '../../shared/utils';
import { consts } from '../../consts';
import { AdvisorModel, Partner } from './advisor.model';
import { AdvisorConst } from './const';
import { AdvisorService } from './advisor.service';
import { AdvisorDialogDeleteComponent } from './advisor-dialog-delete.component';
import { AdvisorFormComponent } from './advisor-form.component';
import { AdvisorDialogInfoDialog } from './advisor-dialog-info.component';

@Component({
    selector: 'app-advisor-list',
    templateUrl: './advisor-list.component.html',
    styleUrls: ['./advisor-list.component.css'],
    standalone: false
})
export class AdvisorListComponent implements OnInit {
  dataSource: AdvisorModel[] = [];
  headerTable: any[] = AdvisorConst.headerTable;
  ready = false;
  empty: boolean = true;
  rowId: number;

  constructor(
    public advisorService: AdvisorService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private router: Router,
    public snackBar: MatSnackBar,
  ) { }

  public ngOnInit() {
    this.dataSource = [];
    this.advisorService.getList().then(
      data => {
        this.dataSource = data;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public create(): void {
    this.dialog.open(AdvisorFormComponent, {
      data: {},
    });
  }

  public edit(uid: number): void {
    this.dialog.open(AdvisorFormComponent, {
      data: { uid: uid },
    })
  }
  public PartnerInfo(partner: Partner[]): void {
    this.dialog.open(AdvisorDialogInfoDialog, {
      data: { Partner:partner},
    })
  }

  public delete(uid: number) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(AdvisorDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    this.snackBar.open(message, "", options);
  }
  public trackByIndex(i: number) { return i; }

}
